import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape, TackNotificationsShape, PeopleNotificationsShape, NavigationShape } from '../shapes';
import HeaderMenu from './header_menu';
import PropTypes from 'prop-types';
import logo from '../images/yak-head.png';

export default class Header extends React.Component {
  static propTypes = {
    navigation: NavigationShape,
    user: UserShape,
    tackNotifications: TackNotificationsShape,
    peopleNotifications: PeopleNotificationsShape,
    onLogout: PropTypes.func
  }

  render() {
    return(
      <header className='row'>
        { this.renderLogo() }
        { this.renderUser() }
      </header>
    );
  }

  renderUser() {
    if (this.props.user.get('loggedIn')) {
      return (
        <span className='login-area'>
          <span className='hidden-on-mobile'>
            Hello, { this.props.user.get('email') }
            <span className='dot-spacer'></span>
          </span>
          <Link to= {'/tack_board' }>
            <span className='board-link'><b>tack board</b></span>
          </Link>
          { this.renderUnreadTackNotificationCount() }
          <span className='dot-spacer'></span>
          <Link to= {'/people_board' }>
            <span className='board-link'><b>people board</b></span>
          </Link>
          { this.renderUnreadPeopleNotificationCount() }
          <span className='dot-spacer'></span>
          <HeaderMenu user={ this.props.user } tackNotifications={ this.props.tackNotifications } onLogout={ this.props.onLogout } />
        </span>
      )
    } else {
      return (
        <span className='login-area'>
          <Link className='login' to={ '/account/login' }>log in</Link>
          <span className='dot-spacer'></span>
          <Link className='login' to={ '/account/create' }>sign up</Link>
        </span>
      );
    }
  }

  renderLogo() {
    if (this.props.navigation.get('pathname') === '/') {
      return null;
    } else {
      return (
        <span className='logo-area'>
          <Link to= {'/' }>
            <img src={ logo } className="logo" alt="yak tack" />
          </Link>
        </span>
      );
    }
  }

  renderUnreadTackNotificationCount() {
    if (this.props.tackNotifications.get('unreadCount') > 0) {
      return (
        <span className='unread-notification badge badge-pill badge-danger'>{ this.props.tackNotifications.get('unreadCount') }</span>
      );
    } else return null;
  }

  renderUnreadPeopleNotificationCount() {
    if (this.props.peopleNotifications.get('unreadCount') > 0) {
      return (
        <span className='unread-notification badge badge-pill badge-danger'>{ this.props.peopleNotifications.get('unreadCount') }</span>
      );
    } else return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/header.jsx